import { ChangeDetectionStrategy, Component, Input, Signal, computed } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';

import { IBetBuilderPickState } from '../../../bet-builder/models';
import { BetBuilderPick } from '../../../linear-bet-builder/models';
import { selectBetBuilderPicks, selectBetBuilderTypeStatePicks } from '../../../linear-bet-builder/selectors';
import { RemoveButtonStyle } from '../../../picks/components/digital/pick-remove-button/remove-button-style';

@Component({
    selector: 'bs-linear-bet-builder-combo-list',
    templateUrl: './linear-bet-builder-combo-list.component.html',
    styleUrls: ['./linear-bet-builder-combo-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearBetBuilderComboListComponent {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() removeButtonStyle: RemoveButtonStyle;

    readonly picks: Signal<BetBuilderPick[]>;
    readonly betBuilderStates: Signal<Record<string, IBetBuilderPickState>>;
    readonly showList: Signal<boolean>;
    readonly betCount: Signal<number>;

    constructor(store: Store) {
        this.picks = store.selectSignal(selectBetBuilderPicks);
        this.showList = computed(() => this.picks().length > 0);
        this.betBuilderStates = store.selectSignal(selectBetBuilderTypeStatePicks);
    }

    getSelectionState(pick: BetBuilderPick): IBetBuilderPickState {
        return this.betBuilderStates()[pick.id.toString()];
    }
}
